import { useBuildingPackageId, useProjectId, useServiceName } from '@consigli/hooks';
import { ServiceName } from '@consigli/types';
import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { WorkspaceProvider } from '@/layouts/workspace-layout/use-workspace-context';
import { WorkspaceLayout } from '@/layouts/workspace-layout/workspace-layout';
import { Route } from '@/routes';

export const LoadCalculationInProgress: FC = () => {
  const { t } = useTranslation();

  const projectId = useProjectId();
  const buildingPackageId = useBuildingPackageId();
  const serviceName = useServiceName();

  const buildingPackageTabs = useMemo(
    () => [
      {
        href: (_serviceName: ServiceName, _projectId: number, _serviceId: string) =>
          `/${Route.PROJECTS}/${projectId}/${Route.SERVICES}/${serviceName}/${Route.PACKAGES}/${buildingPackageId}/${Route.PROCESSING_LOAD_CALCULATION}`,
        name: 'building-tabs.processing-load-calc',
      },
    ],
    [projectId, serviceName, buildingPackageId],
  );

  return (
    <WorkspaceProvider>
      <WorkspaceLayout customTabs={buildingPackageTabs}>
        <div className="pt-52 flex items-center justify-center py-8">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-lg shadow-lg p-8 text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('load-calculation-in-progress.title')}
              </h2>

              <p className="text-gray-600 mb-4">{t('load-calculation-in-progress.description')}</p>

              <p className="text-gray-600 mb-8">{t('load-calculation-in-progress.instruction')}</p>
            </div>
          </div>
        </div>
      </WorkspaceLayout>
    </WorkspaceProvider>
  );
};
